// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cc5a6db9","455":"b7a943ee","477":"a3454484","512":"db7d0fd8","540":"8457148d","816":"ac344c16","831":"bbbca61f","981":"0743a977"}[chunkId] + ".chunk.js";
};